import LabScene from './scene/LabScene';
import FizzySpeech from './FizzySpeech';
import MixingBench from './MixingBench';
import ReactionGif from './ReactionGif';
import ReactionSummary from './ReactionSummary';
import { MIXING_CARD_CLASSES } from '../constants/classNames';
import { MIX_PHASES } from '../constants/labPhases';
import '../styles/MixingCard.css';

/**
 * The lab bench: SVG scene of Fizzy with the flasks and beaker, Fizzy's
 * speech bubble, and the Mix / Clear controls.
 */
export default function MixingCard({ lab, assistantState }) {
  const { selectedSubstances, currentReaction, mixPhase, mixCount, canMix, mixSelectedSubstances, resetBench, toggleSubstance } = lab;
  const { assistant, currentMessage, isTalking, isReadAloudOn, canReadAloud, toggleReadAloud, showNextTip } =
    assistantState;
  const isMixing = mixPhase === MIX_PHASES.PLAYING;

  return (
    <section className={MIXING_CARD_CLASSES.root} aria-label="Mixing bench">
      <div className={MIXING_CARD_CLASSES.stageRow}>
        <div className={MIXING_CARD_CLASSES.sceneWrapper}>
          <LabScene
            selectedSubstances={selectedSubstances}
            reaction={currentReaction}
            mixPhase={mixPhase}
            mixCount={mixCount}
            isTalking={isTalking}
          />
          {isMixing && currentReaction && <ReactionGif key={mixCount} reaction={currentReaction} />}
        </div>
        <div className={MIXING_CARD_CLASSES.speechWrapper}>
          <FizzySpeech
            assistantName={assistant.name}
            message={currentMessage}
            isReadAloudOn={isReadAloudOn}
            canReadAloud={canReadAloud}
            onToggleReadAloud={toggleReadAloud}
            onShowTip={showNextTip}
          />
        </div>
      </div>

      <MixingBench
        selectedSubstances={selectedSubstances}
        canMix={canMix}
        isMixing={isMixing}
        onMix={mixSelectedSubstances}
        onReset={resetBench}
        onRemoveSubstance={toggleSubstance}
      />

      {mixPhase === MIX_PHASES.EXPLAINED && currentReaction && <ReactionSummary reaction={currentReaction} />}
    </section>
  );
}
